import { humanise } from '../lib/format'

/**
 * Status → tone, matching the hue semantics the app uses (green done, amber
 * pending, red rejected) so a status means the same thing in both places.
 */
const TONES: Record<string, string> = {
  approved: 'green',
  pending_approval: 'amber',
  pending_fulfillment_assignment: 'blue',
  rejected: 'red',
  refunded: 'orange',
  layby: 'purple',
  parked: 'teal',
  historical: 'grey',
  // fulfillment_status values
  fulfilled: 'green',
  partially_fulfilled: 'amber',
  unfulfilled: 'grey',
  dispatched: 'teal',
  // delivery schedules, schedule items and outcomes
  pending_assignment: 'amber',
  assigned: 'blue',
  in_progress: 'teal',
  completed: 'green',
  unscheduled: 'grey',
  scheduled: 'blue',
  delivered: 'green',
  partial: 'amber',
  undelivered: 'red',
  // audit trail: requests from the warehouse
  pickup_requested: 'blue',
  pickup_request_added: 'blue',
  pickup_request_cancelled: 'orange',
  pickup_request_closed: 'orange',
  pickup_item_unavailable: 'red',
  warehouse_dispatched: 'teal',
  fulfillment_type_changed: 'orange',
}

export function StatusChip({ status }: { status: string | null | undefined }) {
  if (!status) return <span className="cell-sub">—</span>
  const tone = TONES[status] ?? 'grey'
  return <span className={`chip ${tone}`}>{humanise(status)}</span>
}
